export const LEARN_MORE = 'https://docs.prebid.org/dev-docs/modules/userId.html#user-id-sub-modules'
